import { alpha } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  visibleBackdrop: {
    position: 'absolute',
    width: '100%',
    top: theme.spacing(-1),
    bottom: 0,
    backgroundColor: alpha(theme.palette.secondary.main, 0.5),
    zIndex: 2,
  },

  invisibleBackdrop: {
    zIndex: 2,
  },

  dialog: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: theme.spacing(1),

    left: 0,
    right: 0,
    margin: theme.spacing(3, 'auto'),
    maxWidth: 'clamp(40%, 450px, 90%)',
    position: 'absolute',
    zIndex: 2,
  },

  submitSpinner: {
    right: 'auto',
    padding: theme.spacing(),
  },

  captchaPolicy: {
    display: 'block',
    marginTop: theme.spacing(2),
    color: 'inherit',
    fontSize: 10,

    '& > a': {
      color: 'inherit',
      fontWeight: 'bold',
    },
  },
}));
